import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

const DataDisplay = ({ title, value, prefix }) => (
  <div className="col-2">
    <h4 className="text-warning tc">{title}</h4>
    <h3 style={{ padding: "5px 30px" }} className="bg-white">
      <NumberFormat
        displayType="text"
        className="bg-white f4 font-weight-bold border-0"
        thousandSeparator={true}
        value={Number(value) ? Number.isInteger(Number(value)) ? Number(value) : Number(value).toFixed(2) : 0}
        prefix={prefix}
      />
    </h3>
  </div>
);

const FooterOfRozhana = () => {
  return (
    <ProductConsumer>
      {(value) => {
        const data = [
          { title: "پارەی نەدراو", value: value.d_paraynadraw$, prefix: "$" },
          { title: "وەرگرتنەوەی قەرز", value: value.d_wargrtnawayQarz$, prefix: "$" },
          { title: "پارەی وەرگیراو", value: value.d_paraywargeraw$, prefix: "$" },
          { title: "فرۆشراوەکان", value: value.d_froahraw$, prefix: "$" },
          { title: "یوسف", value: value.d_yassin$, prefix: "$" },
          { title: "ئەنوەر", value: value.d_rahel$, prefix: "$" },
        ];

        const idData = [
          { value: value.d_paraynadrawID, prefix: "ID" },
          { value: value.d_wargrtnawayQarzID, prefix: "ID" },
          { value: value.d_paraywargerawID, prefix: "ID" },
          { value: value.d_froshrawID, prefix: "ID" },
          { value: value.d_yassinID, prefix: "ID" },
          { value: value.d_rahelID, prefix: "ID" },
        ];

        const additionalData = [
          // { title: "FIB پارەی", value: value.d_fib, prefix: "$" },
          { title: "پارەی کاش", value: value.d_cash, prefix: "$" },
          { title: "داشکان", value: value.d_dashkan, prefix: "$" },
          { title: "پارەدان", value: value.d_koyparadandolar, prefix: "$" },
          { title: "مافی کۆمپانا", value: value.d_koyparakomdolar, prefix: "$" },
          // { title: "Rماف و پارەدان", value: value.d_koyparadanRRR, prefix: "پ-R" },
        ];

        const additionalIdData = [
          { value: value.d_fib_Iqd, prefix: "ID" },
          { value: value.d_cash_Iqd, prefix: "ID" },
          { value: value.d_dashkan_iqd, prefix: "IQD" },
          { value: value.d_koyparadandinar, prefix: "IQD" },
          { value: value.d_koyparakomdinar, prefix: "IQD" },
          { value: value.d_koyparakomRRR, prefix: "م-R" },
        ];

        return (
          <>
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {data.map((item, index) => (
                    <DataDisplay key={index} {...item} />
                  ))}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {idData.map((item, index) => (
                    <DataDisplay key={index} {...item} />
                  ))}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {additionalData.map((item, index) => (
                    <DataDisplay key={index} {...item} />
                  ))}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {additionalIdData.map((item, index) => (
                    <DataDisplay key={index} {...item} />
                  ))}
                </div>
              </div>
            </div>
          </>
        );
      }}
    </ProductConsumer>
  );
};

export default FooterOfRozhana;